import { useRef, useState } from "react";
import CommonModal from "../../ResetContext/components/DumpModal";
import URLType from "./URLType";
import SingleWebpage from "./SingleWebpage";
import { useUserInfo } from "../../../../../context/user";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { isValidUrl } from "./urlValidation";
import env from "../../../../../config/env";

const NewAddWebsiteModal = ({
  isOpen,
  onClose,
  getuploadfiles,
  isSharedKnowledge = false,
}) => {
  const BASE_URL = env.API_URL + "/v1";
  const [urlType, setUrlType] = useState("");
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");
  const [selectedOption, setSelectedOption] = useState([]);
  const [userInfo, , , , userActiveLocation] = useUserInfo();
  const submitUrlsRef = useRef(false);
  const [crawlerModal, setCrawlerModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [scrapedData, setScrapedData] = useState({
    totalUrls: 0,
    urls: [],
    jobId: "",
    loading: false,
  });

  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id)
        ? prev.filter((sid) => sid !== id)
        : prev.length < 10
          ? [...prev, id]
          : prev
    );
  };

  const scrapeWebsite = async (e) => {
    try {
      setLoading(true);

      // Validate website URL using the `validator` package
      if (!isValidUrl(url)) {
        toast.error("Please enter a valid website URL");
        setLoading(false);
        return;
      }

      if (!isSharedKnowledge && selectedOption.length === 0) {
        toast.error("Please select at least one assistant");
        setLoading(false);
        return;
      }

      const payload = { url, profileId: userActiveLocation.id };
      const response = await axios.post(
        `${BASE_URL}/assistant/fetchurl`,
        payload
      );

      if (response?.data) {
        const jobId = response.data.jobId;
        setScrapedData((prev) => ({
          ...prev,
          jobId: response.data.jobId,
        }));

        pollJobStatus(jobId);
      } else {
        toast.error("Failed to initiate scraping. Please try again.");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error initiating scraping:", error);
    }
  };

  const pollJobStatus = async (jobId) => {
    try {
      const statusResponse = await axios.get(
        `${BASE_URL}/assistant/scrape/status?jobId=${jobId}&profileId=${userActiveLocation.id}`
      );

      setScrapedData((prev) => ({
        ...prev,
        totalUrlsu: statusResponse?.data?.data?.total_urls,
      }));
      setCrawlerModal(true);
      setUrlType("webpage");

      // Update UI with scraped URLs as they come
      if (statusResponse?.data?.urls?.length > 0) {
        setScrapedData((prevUrls) => ({
          ...prevUrls,
          urls: [
            ...new Set([...scrapedData.urls, ...statusResponse.data.urls]),
          ],
        }));
      }

      if (
        statusResponse?.data?.data?.status === "in_progress" &&
        !submitUrlsRef.current
      ) {
        pollJobStatus(jobId);
        return;
      }

      setLoading(false);
      fetchScrapedUrls(jobId);
      if (statusResponse?.data?.status === "failed") {
        // setUrlErrorMessage('Failed to complete scraping. Please try again.');
        setLoading(false);
      }
    } catch (error) {
      console.error("Error checking job status:", error);
      // setUrlErrorMessage('Err
    }
  };

  const fetchScrapedUrls = async (jobId) => {
    try {
      const urlsResponse = await axios.get(
        `${BASE_URL}/assistant/scrape/urls?profileId=${userActiveLocation.id}&jobId=${jobId}`
      );

      if (urlsResponse?.data?.data?.length > 0) {
        setScrapedData((prev) => ({
          ...prev,
          urls: [...prev.urls, ...urlsResponse.data.data],
        }));
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching scraped URLs:", error);
      // setUrlErrorMessage('Failed to fetch URLs. Please try again.');
      setLoading(false);
    }
  };

  const scrapedSubmitHandler = async (files) => {
    if (!isSharedKnowledge && (!selectedOption || selectedOption.length === 0)) {
      toast.error("Please select at least one assistant.");
      return;
    }
    // Payload for the request
    setScrapedData((prev) => ({ ...prev, loading: true }));

    const filteredUrls = selected.filter((url) => url != null);

    try {
      const response = isSharedKnowledge
        ? await axios.post(
          `${BASE_URL}/chat/profiles/${userActiveLocation?.id}/website/upload`,
          {
            job_id: scrapedData.jobId,
            urls: filteredUrls,
            username: userInfo?.userName,
          }
        )
        : await axios.post(`${BASE_URL}/chat/assistants/website/upload`, {
          assistant_ids: selectedOption?.map((item) => item.value),
          profile_id: userActiveLocation?.id,
          website: filteredUrls,
          username: userInfo?.userName,
          jobId: scrapedData.jobId,
        });

      if (response) {
        submitUrlsRef.current = true;
        getuploadfiles();
        onClose(false);
        toast.success(response?.data?.message || "Webpages added successfully!");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        "There was an error uploading the website. Please try again."
      );
    }
    setScrapedData((prev) => ({ ...prev, loading: false }));
  };

  const singleUrlSubmit = async () => {
    // Validate URL using the `validator` package (same rule used for scraping)
    if (!isValidUrl(url)) {
      toast.error("Please enter a valid URL");
      return;
    }
    if (!isSharedKnowledge && (!selectedOption || selectedOption.length === 0)) {
      toast.error("Please select at least one assistant.");
      return;
    }
    setLoading(true);

    try {
      const response = isSharedKnowledge
        ? await axios.post(
          `${BASE_URL}/chat/profiles/${userActiveLocation?.id}/website/upload`,
          {
            webpage_url: url.trim(),
            username: userInfo?.userName,
          }
        )
        : await axios.post(`${BASE_URL}/chat/assistants/website/upload`, {
          assistant_ids: selectedOption?.map((item) => item.value),
          profile_id: userActiveLocation?.id,
          website: url,
          username: userInfo?.userName,
        });

      if (response) {
        submitUrlsRef.current = true;
        getuploadfiles();
        onClose(false);
        toast.success(response?.data?.message || "Webpages added successfully!");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        "There was an error uploading the website. Please try again."
      );
    }
    setLoading(false);
  };

  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        urlType === ""
          ? "Add a URL"
          : urlType === "single"
            ? "Add a Webpage"
            : urlType === "multi"
              ? "Add a Website"
              : "Select Webpages"
      }
      showAlert={false}
    >
      {urlType === "" && <URLType setUrlType={setUrlType} />}
      {(urlType === "single" ||
        urlType === "multi" ||
        urlType === "webpage") && (
          <SingleWebpage
            urlType={urlType}
            isSharedKnowledge={isSharedKnowledge}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            url={url}
            setUrl={setUrl}
            scrapedData={scrapedData}
            loading={loading}
            scrapeWebsite={scrapeWebsite}
            handleSelect={handleSelect}
            selected={selected}
            crawlerModal={crawlerModal}
            submitHandler={
              urlType === "single" ? singleUrlSubmit : scrapedSubmitHandler
            }
          />
        )}
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          style: { zIndex: 2147483647 },
        }}
      />
    </CommonModal>
  );
};

export default NewAddWebsiteModal;
